import axios from '@/jslib/axios'

export const getCouponList = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/list',
    params
  })
}

export const getUseCouponList = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/use/list',
    params
  })
}
export const editCoupon = data => {
  return axios({
    method: 'patch',
    url: '/admin/coupon',
    data
  })
}
export const getCouponDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/detail',
    params
  })
}
export const addCoupon = data => {
  return axios({
    method: 'post',
    url: '/admin/coupon',
    data
  })
}
export const addSMECoupon = data => {
  return axios({
    method: 'post',
    url: '/admin/coupon/manual/quote',
    data
  })
}
export const getUserCoupon = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/user',
    params
  })
}
export const deleteUserCoupon = data => {
  return axios({
    method: 'delete',
    url: '/admin/coupon/user',
    data
  })
}
export const addUserCoupon = data => {
  return axios({
    method: 'post',
    url: '/admin/coupon/user/add',
    data
  })
}
export const couponOption = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/option',
    params
  })
}
export const orderUseCoupon = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/order/use',
    params
  })
}
export const getQuoteCouponList = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/quote',
    params
  })
}
export const getSmeCouponList = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/manual/quote/list',
    params
  })
}
export const getCouponCategory = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/user/category',
    params
  })
}
export const replySmeCoupon = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/coupon/reply',
    data
  })
}
export const referUserQuote = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/user/quote',
    params
  })
}
export const referCouponQuoteList = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/list/quote',
    params
  })
}

export const getAlipayList = params => {
  return axios({
    method: 'get',
    url: '/admin/coupon/alipay/quote/list',
    params
  })
}

export const createAlipayCoupon = data => {
  return axios({
    method: 'post',
    url: '/admin/coupon/alipay/create',
    data
  })
}

export const editAlipayCoupon = data => {
  return axios({
    method: 'patch',
    url: '/admin/coupon/alipay/edit',
    data
  })
}


